<template>
  <!-- Face Templates Modal -->
  <div id="face_templates_modal" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-4">
          <h2 class="modal-title mb-4">Face</h2>

          <!-- Upload Section -->
          <div class="d-flex align-items-center mb-4">
            <div class="input-group me-2" @click="$refs.fileInput.click()" style="cursor: pointer;">
              <input type="text" class="form-control" placeholder="Select images" readonly :value="selectedFileName" style="cursor: pointer;">
              <input type="file" ref="fileInput" class="d-none" @change="onFileChange" accept="image/*">
            </div>
            <span class="icon-circle" style="cursor: pointer;" @click="$refs.fileInput.click()" :class="{ 'disabled': uploading }">
              <i class="fa-solid fa-upload"></i>
            </span>
          </div>

          <div v-if="loading" class="d-flex justify-content-center py-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else>
            <div class="face-template-list">
              <div v-for="(t, index) in templates" :key="index" class="face-template-item d-flex align-items-center justify-content-center mb-3">
                <div class="circular-img-wrapper">
                  <img :src="getImage(t.image_path)" alt="Face Template" class="face-template-img" />
                </div>
                <span class="icon-circle text-danger ms-3" style="cursor: pointer;" @click="deleteTemplate(t.id)" :class="{ 'disabled': t.deleting }">
                   <div v-if="t.deleting" class="spinner-border spinner-border-sm" role="status"></div>
                   <i v-else class="fa-solid fa-trash-can"></i>
                </span>
              </div>
            </div>
            
            <div v-if="templates.length === 0" class="text-center py-4">
              <p class="text-muted">No face templates found.</p>
            </div>
          </div>

          <div class="text-end mt-4">
            <button type="button" class="btn btn-link text-danger text-uppercase text-decoration-none p-0" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Face Templates Modal -->
</template>

<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../config";
import { Modal } from "bootstrap";
import { getImage } from "@/utils/util-funcitons";

export default {
  data() {
    return {
      loading: false,
      uploading: false,
      templates: [],
      employeeName: '',
      userId: null,
      selectedFile: null,
      selectedFileName: '',
    };
  },
  methods: {
    async showTemplates(employee) {
      this.employeeName = employee.name || `${employee.first_name || ''} ${employee.last_name || ''}`.trim();
      this.userId = employee.id || employee.user_id;
      this.templates = [];
      this.selectedFile = null;
      this.selectedFileName = '';
      this.fetchTemplates();
      
      const modal = new Modal(document.getElementById('face_templates_modal'));
      modal.show();
    },

    async fetchTemplates() {
      this.loading = true;
      try {
        const response = await axios.get(`${VUE_APP_API_BASE_URL}/face-template/get`, {
          params: { user_id: this.userId }
        });
        if (response.data.status) {
          this.templates = response.data.data.map(t => ({ ...t, deleting: false }));
        } else {
          this.$toast.error(response.data.message || 'Failed to fetch face templates');
        }
      } catch (error) {
        console.error(error);
        this.$toast.error('Failed to fetch face templates');
      } finally {
        this.loading = false;
      }
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.selectedFileName = file.name;
        this.uploadTemplate();
      }
    },

    async uploadTemplate() {
      if (!this.selectedFile) return;

      this.uploading = true;
      const formData = new FormData();
      formData.append("image", this.selectedFile);
      formData.append("user_id", this.userId);

      try {
        const response = await axios.post(`${VUE_APP_API_BASE_URL}/face-template/add`, formData);
        if (response.data.status) {
          this.$toast.success('Face template uploaded successfully');
          this.selectedFile = null;
          this.selectedFileName = '';
          this.fetchTemplates();
        } else {
          this.$toast.error(response.data.message || 'Failed to upload face template');
        }
      } catch (error) {
        console.error(error);
        this.$toast.error('Failed to upload face template');
      } finally {
        this.uploading = false;
      }
    },

    async deleteTemplate(templateId) {
      const t = this.templates.find(item => item.id === templateId);
      if (t) t.deleting = true;

      try {
        const response = await axios.post(`${VUE_APP_API_BASE_URL}/face-template/delete`, { id: templateId });
        if (response.data.status) {
          this.$toast.success('Face template deleted successfully');
          this.fetchTemplates();
        } else {
          this.$toast.error(response.data.message || 'Failed to delete face template');
          if (t) t.deleting = false;
        }
      } catch (error) {
        console.error(error);
        this.$toast.error('Failed to delete face template');
        if (t) t.deleting = false;
      }
    },

    getImage,
  },
};
</script>

<style scoped>
.modal-title {
  font-size: 2rem;
  font-weight: 500;
  color: #333;
}

.circular-img-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #ddd;
}

.face-template-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.face-template-item {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}

.face-template-item:last-child {
  border-bottom: none;
}

.icon-circle {
    display: flex;
    background-color: #f7f7f7;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
}

.icon-circle.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.input-group .form-control {
  border-right: 1px solid #ced4da;
  height: 44px;
}
</style>
